import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { autobind } from 'core-decorators'
import { observer } from 'mobx-react'
import { autorun } from 'mobx'
import { IoMdPin } from 'react-icons/io'

import GenevaButton from '../../shared/components/GenevaButton'
import ScreenshotDialog from './modals/ScreenshotDialog'
import { IApplicationStore, IReviewStore } from '../../stores'
import { IScreenshotBasic } from '../../models'

// Typescript specific cast
const globalAny:any = global

interface IScreenshotProps {
  reviewStore: IReviewStore,
  applicationStore: IApplicationStore
}

interface IState {
  showScreenshotModal: boolean,
  canvasData: string,
  screenshotMode: boolean,
}

@observer
export default class Screenshot extends Component <IScreenshotProps> {
  state: IState
  // eslint-disable-next-line react/sort-comp
  iframeWindow: any

  // eslint-disable-next-line react/sort-comp
  constructor(props) {
    super(props)
    this.state = {
      showScreenshotModal: false,
      canvasData: '',
      screenshotMode: false
    }
  }

  componentDidMount() {
    const { applicationStore } = this.props

    autorun(() => {
      if (!applicationStore.showScreenshotIndicator && this.state.screenshotMode) {
        this.handleExitScreenshotMode()
      }
    })
  }

  @autobind
  keyDownHandler(event): void {
    if (event.keyCode === 27) {
      this.setState({
        showScreenshotModal: false,
        screenshotMode: false
      })
      this.exitScreenshotMode()
    }
  }

  @autobind
  handleEnterScreenshotMode() {

    window.addEventListener('keyup', this.keyDownHandler, false)

    window.addEventListener('message', this.handleImageData, false)

    this.sendMessageToFrame('screenshotModeEntered')

    this.setState({
      screenshotMode: true
    })

    this.props.applicationStore.showScreenshotIndicatorView(true)
  }

  @autobind
  handleExitScreenshotMode() {

    window.removeEventListener('keyup', this.keyDownHandler, false)

    window.removeEventListener('message', this.handleImageData, false)

    this.sendMessageToFrame('screenshotModeLeft')

    this.setState({
      showScreenshotModal: false,
      screenshotMode: false
    })
  }

  @autobind
  handleSaveScreenshot(dialogData: { imageURL: string, text: string }) {

    this.exitScreenshotMode()

    const screenshotData: IScreenshotBasic = {
      image: dialogData.imageURL,
      dotX: 100, // todo: get click data from iframe
      dotY: 100, // todo: get click data from iframe
      text: dialogData.text,
      resolution: window.innerWidth
    }

    this.props.reviewStore.createImage(screenshotData)
  }

  @autobind
  exitScreenshotMode() {
    this.props.applicationStore.showScreenshotIndicatorView(false)
  }

  @autobind
  handleImageData(messageEvent: { data: string }) {
    if (typeof messageEvent.data === 'string') {
      this.setState({
        showScreenshotModal: true,
        canvasData: messageEvent.data
      })
    }
  }

  sendMessageToFrame(data: string) {
    if (globalAny.refIFrame) {
      this.iframeWindow = globalAny.refIFrame.contentWindow
      this.iframeWindow.postMessage(data, this.props.applicationStore.iframeUrl)
    }
  }

  renderScreenshotModal() {
    const { canvasData } = this.state

    if (!canvasData) {
      return null
    }

    return (
      <ScreenshotDialog
        imageURL={canvasData}
        handleClose={this.exitScreenshotMode}
        handleConfirm={this.handleSaveScreenshot}
      />
    )
  }

  render() {

    return (
      <div>
        <GenevaButton
          className="small button"
          onClick={this.handleEnterScreenshotMode}
        >
          <IoMdPin
            size={22}
            color="#ff0000"
          />
          <FormattedMessage id="review-center.chat.red-point" />
        </GenevaButton>

        {this.state.showScreenshotModal
          ? this.renderScreenshotModal()
          : null}
      </div>
    )
  }
}
